var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detail-text"},[(_vm.showType === '4' || _vm.showType === '2')?_c('div',{class:_vm.type},[_vm._v("\n    "+_vm._s(_vm.title)+": "+_vm._s(_vm.value)+"\n  ")]):_vm._e(),(_vm.showType === '5')?_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.value))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }